import styled from 'styled-components';

export const ShadePickerSlider = styled.div`
    .elc-slider-arrow-wrapper.slick-next,
    .elc-slider-arrow-wrapper.slick-prev {
        height: auto;
        width: auto;
        margin-top: 0;
        z-index: 0;
    }

    .elc-slider-arrow-wrapper.slick-next {
        [dir='rtl'] & {
            right: -15px;
            left: auto;
        }
    }
`;
export const StyledCircleIcon = styled.div`
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background-color: ${({ color }: { color?: string }) => color};
`;
